export default __webpack_public_path__ + "static/media/Pistol_6.0256b5b6.png";